import {useEffect, useState} from "react";

const useDashboardEditMode = (): boolean => {
    const [editMode, setEditMode] = useState(window.isEditMode)
    useEffect(() =>{
        const listener = () => setEditMode(window.isEditMode);

        window.addEventListener("editMode", listener)

        return () => window.addEventListener("editMode", listener)
    },[])

    return editMode;
};

export default useDashboardEditMode;
